
export const motivationalTexts = [
  "Prends soin de toi...",
  "Ta peau mérite le meilleur...",
  "En route vers une peau rayonnante...",
  "Découvrons ensemble ta routine idéale..."
];
